<template>
  <div>
    <!-- Trim preview player -->
    <preview-player-modal
      :visible="openedModal == modals.PREVIEW"
      :begin-time="leftCropBound"
      :end-time="rightCropBound"
      @close="closeClipperModal"
    />
    <calendar-info-modal
      :show="openedModal == modals.CALENDAR"
      @close="closeClipperModal"
      @selectCalendarDay="$emit('selectCalendarDay', $event)"
      @stopPlayerCalendar="$emit('stopPlayerCalendar')"
      @returnUpdateStream="$emit('returnUpdateStream', $event)"
    />
    <!-- Shortuts helper -->
    <shortcuts-info-modal
      :visible="openedModal == modals.SHORTCUTS"
      @close="closeClipperModal"
    />
    <!-- Timezone select -->
    <timezone-select-modal
      :channel-id="channelId"
      :show="openedModal == modals.TIMEZONE"
      @close="closeClipperModal"
    />
    <!-- Snapshot loader -->
    <snapshot-modal
      :visible="openedModal == modals.SNAPSHOT"
      :player="snapshotPlayer"
      :filename="snapshotFilename"
      @close="closeClipperModal"
    />
    <!-- Audio preview -->
    <audio-watch-modal
      :visible="openedModal == modals.WATCH_AUDIO"
      :name="audioName"
      :link="audioLink"
      @close="closeClipperModal"
    />
    <notifications
      v-if="modalData"
      :visible="openedModal == modals.MESSAGEMODAL"
      :name="audioName"
      :link="audioLink"
      @close="closeClipperModal"
    />
  </div>
</template>

<script>
/** vuex */
import { mapState, mapActions } from "vuex";

/** modals */
import PreviewPlayerModal from "@/components/dialog/PreviewPlayerModal.vue";
import ShortcutsInfoModal from "@/components/dialog/ShortcutsInfoModal.vue";
import CalendarInfoModal from "@/components/dialog/CalendarInfoModal.vue";
import TimezoneSelectModal from "@/components/timezone/TimezoneSelectModal.vue";
import SnapshotModal from "@/components/media/snapshot/SnapshotModal.vue";
import AudioWatchModal from "@/components/dialog/AudioWatchModal.vue";
import Notifications from "@/components/dialog/Notifications.vue";

// @group Dialog
// Manager, that controls showing/closing of clipper modals
export default {
  name: "ModalsManager",
  components: {
    PreviewPlayerModal,
    ShortcutsInfoModal,
    TimezoneSelectModal,
    SnapshotModal,
    AudioWatchModal,
    CalendarInfoModal,
    Notifications
  },
  props: {
    channelId: {
      type: String
    }
  },
  watch: {
    openedModal(){
      this.$emit("selectModal", this.openedModal)
    }
  },
  computed: {
    ...mapState({
      /** modals */
      modals: state => state.modals.clipper.MODALS,
      openedModal: state => state.modals.clipper.opened,
      modalData: state => state.modals.clipper.modalData,

      /** crop bounds for preview */
      leftCropBound: state => state.timeline.sliderLeftBound,
      rightCropBound: state => state.timeline.sliderRightBound,

      facebookAccounts: state => state.socials.facebook.accounts
    }),
    // @vuese
    // Snapshot filename or undefined (if modal data is null)
    snapshotFilename() {
      return this.modalData?.filename;
    },
    // @vuese
    // Player to get snapshot object or undefined (if modal data is null)
    snapshotPlayer() {
      return this.modalData?.player;
    },
    // @vuese
    // Audio item's name or undefined (if modal data is null)
    audioName() {
      return this.modalData?.name;
    },
    // @vuese
    // Audio item's playing link or undefined (if modal data is null)
    audioLink() {
      return this.modalData?.link;
    },
    // @vuese
    // All facebook pages binded to accounts
    facebookPages() {
      const allPages = this.facebookAccounts.reduce((pages, account) => {
        if (account.pages) {
          const markedPages = account.pages.map(p => ({
            ...p,
            accountId: account.id
          }));
          pages.push(...markedPages);
        }
        return pages;
      }, []);
      return allPages;
    }
  },
  methods: {
    ...mapActions("modals", ["openClipperModal", "closeClipperModal"])
  }
};
</script>
